import { animate, keyframes, state, style, transition, trigger } from "@angular/animations";
import { Component, Input } from "@angular/core";
import { Toast, ToastrService, ToastPackage } from "ngx-toastr";
@Component({ standalone: false,
  selector: 'enact-alert-snack-bar',
  templateUrl: './enact-alert-snack-bar.component.html',
  styleUrls: ['./enact-alert-snack-bar.component.scss'],
  animations: [
    trigger("flyInOut", [
      state(
        "inactive",
        style({
          display: "none",
          opacity: 0
        })
      ),
      transition(
        "inactive => active",
        animate(
          "400ms ease-out",
          keyframes([
            style({
              opacity: 0
            }),
            style({
              opacity: 1
            })
          ])
        )
      ),
      transition(
        "active => removed",
        animate(
          "400ms ease-out",
          keyframes([
            style({
              opacity: 1
            }),
            style({
              transform: "translate3d(10%, 0, 0) skewX(10deg)",
              opacity: 0
            })
          ])
        )
      )
    ])
  ],
  preserveWhitespaces: false
})
export class EnactAlertSnackBarComponent extends Toast {

  @Input() toast!: Toast;

  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage
  ) {
        super(toastrService, toastPackage);
  }

}
